import React from "react";
import { constants } from "@thecb/components";

const NewTabIcon = () => {
  const color = constants.colors.LUCKY_POINT;
  return (
    <svg
      width="18px"
      height="18px"
      viewBox="0 0 18 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Search-Results---One"
          transform="translate(-1266.000000, -411.000000)"
        >
          <g
            id="Customers-Table-/-Row"
            transform="translate(132.000000, 384.000000)"
          >
            <g id="icon---new-tab" transform="translate(1134.000000, 27.000000)">
              <path
                d="M1,18 C0.44771525,18 6.76353751e-17,17.5522847 0,17 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 L6,0 C6.55228475,-1.01453063e-16 7,0.44771525 7,1 C7,1.55228475 6.55228475,2 6,2 L2,2 L2,16 L16,16 L16,12 C16,11.4477153 16.4477153,11 17,11 C17.5522847,11 18,11.4477153 18,12 L18,17 L18,17 C18,17.5128358 17.6139598,17.9355072 17.1166211,17.9932723 L17,18 L17,18 L1,18 L1,18 Z"
                id="box"
                fill={color}
              ></path>
              <path
                d="M17,0 C17.5522847,-1.01453063e-16 18,0.44771525 18,1 L18,6 C18,6.55228475 17.5522847,7 17,7 C16.4477153,7 16,6.55228475 16,6 L16,2 L12,2 C11.4477153,2 11,1.55228475 11,1 C11,0.44771525 11.4477153,1.01453063e-16 12,0 L17,0 L17,0 Z"
                id="arrowhead"
                fill={color}
              ></path>
              <line
                x1="17"
                y1="1"
                x2="7"
                y2="11"
                id="Path"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default NewTabIcon;
